import React from 'react'

/**
 * Comment Dialog Component
 * Handles adding/editing comments for selected elements
 */
const CommentDialog = ({
  showCommentDialog,
  setShowCommentDialog,
  selectedElementComment,
  setSelectedElementComment,
  selectedElement,
  saveElementComment
}) => {
  if (!showCommentDialog) {
    return null
  }

  const handleSave = () => {
    saveElementComment(selectedElement, selectedElementComment)
    setShowCommentDialog(false)
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[550]">
      <div className="bg-white rounded-lg p-6 w-96 max-w-90vw">
        <h3 className="text-lg font-semibold mb-4">Add Comment</h3>
        <textarea
          value={selectedElementComment}
          onChange={(e) => setSelectedElementComment(e.target.value)}
          placeholder="Enter your comment..."
          className="w-full h-32 border border-gray-300 rounded px-3 py-2 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <div className="flex justify-end space-x-2 mt-4">
          <button
            onClick={() => setShowCommentDialog(false)}
            className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-blue-500 text-white hover:bg-blue-600 rounded"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  )
}

export default CommentDialog
